require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ignite-askmeanything.json") })
        }
      }, "path---ignite-askmeanything");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ignite-askmeanything!./.cache/json/ignite-askmeanything.json
// module id = 1082
// module chunks = 231608221292675